/* eslint-disable */
import MainCard from "components/MainCard";
import { useEffect, useRef, useState } from "react";
import ECharts from 'echarts-for-react';
import useConfig from 'hooks/useConfig';
import { getDashboardCountByCategoryAndEquipmentStatus, getDashboardCountEquipmentAlertGroupByMonthAndCategory3 } from "components/axios/dashboardAxios";
import { truncateText } from "data/data";
import dayjs from "utils/dayjs";
import { useTranslation } from "react-i18next";

const baseOption = {
  tooltip: {
    trigger: 'axis',
    confine: true,
    axisPointer: { type: 'cross' }
  },
  grid: {
    top: '20%', // 차트 그래픽 영역 위쪽에 공간을 확보하여 툴팁이 올라갈 여백 마련
    left: '3%',
    right: '3%',
    bottom: '3%',
    containLabel: true,
  },
  legend: {
    textStyle: { color: '#fff' }
  },
  xAxis: {
    type: 'category',
    boundaryGap: false
  },
  yAxis: {
    type: 'value'
  },
  series: [],
  animation: false,
};

export function DashboardAreaStackChart({ height="250px" }) {
  const { mode } = useConfig();
  const { t } = useTranslation();
  const [option, setOption] = useState(baseOption);

  const textColor = mode === "light" ? "#262626" : "#ffffff";
  const bgColor = mode === "light" ? "#f9f9fa" : "#2f2f2f";

  const prevDataRef = useRef(null);

  const isSameChartData = (prev, next) => {
    if (!prev) return false;

    if (prev.categories.join() !== next.categories.join()) return false;

    if (prev.series.length !== next.series.length) return false;

    for (let i = 0; i < prev.series.length; i++) {
      if (prev.series[i].name !== next.series[i].name) return false;

      const prevValues = prev.series[i].data.map(d => d.value);
      const nextValues = next.series[i].data.map(d => d.value);

      if (prevValues.join() !== nextValues.join()) return false;
    }

    return true;
  };

  useEffect(() => {
    let timer;

    const fetchChartData = async () => {
      const [ctgrRes, alertRes] = await Promise.all([
        getDashboardCountByCategoryAndEquipmentStatus(),
        getDashboardCountEquipmentAlertGroupByMonthAndCategory3({})
      ]);

      const categories = Array.from({ length: 12 }, (_, i) =>
        dayjs().subtract(11 - i, 'month').format('M') + t('message.common.text.month2')
      );

      const months = Array.from({ length: 12 }, (_, i) =>
        dayjs().subtract(11 - i, 'month').format('YYYY_MM')
      );

      const level3s = ctgrRes.map(d => ({
        id: d.category3Id,
        name: truncateText(d.category3Name.trim(), 12) + '   '
      }));

      const series = level3s.map(lvl3 => ({
        name: lvl3.name,
        type: 'line',
        stack: 'Total',
        areaStyle: {},
        emphasis: { focus: 'series' },
        smooth: true,
        showSymbol: false,
        data: months.map(month => {
          const [y, m] = month.split('_');
          const found = alertRes.find(
            d =>
              d.category3Id === lvl3.id &&
              d.year == y &&
              Number(d.month) === Number(m)
          );

          return {
            value: found ? found.cnt : 0,
            link: found
              ? `/equipment-alert-history-tracking?searchlevel1=${found.category1Id}&searchlevel2=${found.category2Id}&searchlevel3=${found.category3Id}`
              : null
          };
        })
      }));

      const nextData = {
        categories,
        series
      };

      if (isSameChartData(prevDataRef.current, nextData)) {
        // ✅ 데이터 동일 → 차트 유지
        return;
      }

      prevDataRef.current = nextData;

      setOption(prev => ({
        ...prev,
        xAxis: { ...prev.xAxis, data: categories },
        legend: {
          ...prev.legend,
          data: level3s.map(v => v.name),
        },
        series
      }));
    };

    fetchChartData();
    timer = setInterval(fetchChartData, 3000); // ⏱ 1분 주기

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    setOption(prev => ({
      ...prev,
      textStyle: {
        ...prev.textStyle,
        color: textColor
      },
      legend: {
        ...prev.legend,
        textStyle: {
          ...prev.legend?.textStyle,
          color: textColor
        },
        backgroundColor : bgColor
      },
      xAxis: {
        ...prev.xAxis,
        axisLabel: {
          ...prev.xAxis?.axisLabel,
          color: textColor
        }
      },
      yAxis: {
        ...prev.yAxis,
        axisLabel: {
          ...prev.yAxis?.axisLabel,
          color: textColor
        }
      },
      // backgroundColor : bgColor
    }));
  }, [mode]);

  const onChartClick = (params) => {
    // if (params?.data?.link) {
    //   window.open(params.data.link, '_self');
    // }
    const link = params.data?.link;
    if (!link) return;   // ✅ 링크 없으면 아무 동작 안 함

    window.location.href = link;
  };

  return (
    <div className="mixed-chart mixed-chart1" style={{ width: '100%' }}>
      <MainCard content={false}>
        <ECharts
          option={option}
          style={{ width: '100%', height }}
          opts={{ renderer: 'svg' }}
          lazyUpdate={true}
          onEvents={{ click: onChartClick }}
        />
      </MainCard>
    </div>
  );
}

export default DashboardAreaStackChart;